<template>
    <div>
        <div class="columns">

            <div class="column is-one-third">
                <b-field
                    expanded
                    label="Вид подготовки">
                    <b-select
                        expanded
                        @input="onStudentTypeChange"
                        :disabled="preset != null"
                        v-model="item.student_type">
                        <option
                            v-for="type in [
                                'bachelor',
                                'master',
                                'graduate',
                            ]"
                            :value="type"
                            :key="type"
                            v-text="messages.students.type[type]"
                        />
                    </b-select>
                </b-field>
            </div>
            
            <div class="column">
                <b-field
                    expanded
                    label="Тип дисциплины">
                    <subject-type-select
                        expanded
                        v-model="type"
                        @input="onSubjectTypeChange"
                        :restrict="restrictedType"
                        :departments="departments"
                        :disabled="preset != null && restrictedType == null"
                    />
                </b-field>
            </div>
        
        </div>

        <div v-if="type.name == 'generic'">

            <b-field
                expanded
                label="Семестр">
                <b-field>
                    <b-checkbox-button
                        class="is-expanded is-fullwidth"
                        v-for="semester in semesters"
                        :key="semester.number"
                        v-model="item.semesters.no_exams"
                        :native-value="semester.number"
                        :disabled="!semester.exists">
                        <span>{{ semester.number }}</span>
                    </b-checkbox-button>
                </b-field>
            </b-field>

            <b-field></b-field>
            
        </div>

        <div class="columns" v-else>
        
            <div class="column">
                <b-field
                    expanded
                    label="Зачеты">
                    <b-field>
                        <b-checkbox-button
                            class="is-expanded is-fullwidth"
                            v-for="semester in semesters"
                            :key="semester.number"
                            v-model="item.semesters.no_exams"
                            :native-value="semester.number"
                            :disabled="!semester.exists">
                            <span>{{ semester.number }}</span>
                        </b-checkbox-button>
                    </b-field>
                </b-field>
            </div>

            <div class="column">
                <b-field
                    expanded
                    label="Экзамены">
                    <b-field>
                        <b-checkbox-button
                            class="is-expanded is-fullwidth"
                            v-for="semester in semesters"
                            :key="semester.number"
                            v-model="item.semesters.exams"
                            :native-value="semester.number"
                            :disabled="!semester.exists">
                            <span>{{ semester.number }}</span>
                        </b-checkbox-button>
                    </b-field>
                </b-field>
            </div>
        
        </div>

        <template
            v-if="type.name == 'main' && type.details.theoretical == true">
            
        <div class="columns">
            <div class="column">    
                <b-field
                    expanded
                    label="Название"
                    :message="errors.first('title')"
                    :type="errors.has('title') ? 'is-danger' : ''">
                    <b-input
                        @input="onUpdate"
                        name="title"
                        maxlength="128"
                        v-model.trim="item.title"
                        v-validate="'required|max:128'"
                        data-vv-as=" "
                    />
                </b-field>
            </div>
            <div class="column is-half has-text-centered">
                <b-field
                    label="Тип аудиторного занятия">
                    <div class="columns">
                        <div class="column has-text-centered">
                            <b-switch
                                v-model="item.details.lecture">
                                <span>Лекция</span>
                            </b-switch>
                        </div>
                        <div class="column has-text-centered">
                            <b-switch
                                v-model="item.details.seminar">
                                <span>Семинар</span>
                            </b-switch>
                        </div>
                    </div>
                </b-field>
            </div>
        </div>

        <div class="columns">
            <div class="column is-offset-half is-half has-text-centered">
                    <b-switch
                        v-model="item.details.optional">
                        <span>Курс по выбору</span>
                    </b-switch>
            </div>
        </div>

        </template>

        <div class="columns"
            v-else-if="type.name == 'main' && type.details.theoretical == false">
            <div class="column">    
                <b-field
                    expanded
                    label="Название">
                    <b-input
                        @input="onUpdate"
                        name="title"
                        maxlength="128"
                        v-model.trim="item.title"
                        v-validate="'required|max:128'"
                        data-vv-as=" "
                    />
                </b-field>
            </div>
            <div class="column is-half">
                <b-field
                    expanded
                    label="Языковая">
                    <b-select
                        expanded
                        v-model="item.details.linguistic">
                        <option :value="null">Нет</option>
                        <option value="primary">Первый иностранный язык</option>
                        <option value="secondary">Второй иностранный язык</option>
                    </b-select>
                </b-field>
            </div>
        </div>

        <div class="columns" v-else-if="type.name == 'department'">
            <div class="column">
                <b-field
                    expanded
                    label="Название">
                    <b-input
                        @input="onUpdate"
                        name="title"
                        maxlength="128"
                        v-model.trim="item.title"
                        v-validate="'required|max:128'"
                        data-vv-as=" "
                    />
                </b-field>
            </div>
            <div class="column is-one-third has-text-centered">
                <b-field
                    label="Курс по выбору">
                    <b-switch
                        v-model="item.details.optional">
                    </b-switch>
                </b-field>
            </div>
        </div>

        <b-field
            v-if="type.name == 'generic' && type.details.type == 'practice'"
            expanded
            label="Название практики">
            <b-input
                @input="onUpdate"
                name="title"
                maxlength="128"
                v-model.trim="item.title"
                v-validate="'required|max:128'"
                data-vv-as=" "
            />
        </b-field>

        <b-field
            v-else-if="type.name == 'generic' && type.details.type == 'attestation'"
            expanded
            label="Название аттестации">
            <b-input
                @input="onUpdate"
                name="title"
                maxlength="128"
                v-model.trim="item.title"
                v-validate="'required|max:128'"
                data-vv-as=" "
            />
        </b-field>

        <b-field
            expanded
            label="Преподаватели">
            <b-taginput
                attached
                autocomplete
                icon="account"
                field="short_name"
                v-model="item.teachers"
                :data="filteredTeachers"
                placeholder="ФИО преподавателя..."
                @typing="getFilteredTeachers">
                <template slot-scope="props">
<span>{{ $_.get(props.option, 'full_name') }}</span>
<span v-if="$_.get(props.option, 'profile.type') == 'teacher' && 
            $_.get(props.option, 'profile.position')">
({{ $_.get(props.option, 'profile.position.name') }})
</span>
<span v-else>
({{ $t(`users.profile.type.` + $_.get(props.option, 'profile.type')) }})
</span>
                </template>
            </b-taginput>
        </b-field>

    </div>
</template>
<script>
import SubjectTypeSelect from "./subject/components/SubjectTypeSelect";

import messages from "../../mixins/messages";
import toasts from "../../mixins/toasts";

export default Vue.extend({
  props: {
    preset: Object,
    departments: Array,
    teachers: Array
  },
  components: { SubjectTypeSelect },
  mixins: [messages, toasts],
  data() {
    return {
      item: {
        student_type: "bachelor",
        semesters: {
          exams: [],
          no_exams: []
        },
        details: {}
      },
      type: {
        name: "main",
        details: {
          theoretical: true
        }
      },
      restrictedType: null,
      filteredTeachers: []
    };
  },
  watch: {
    item: {
      deep: true,
      handler: "onUpdate"
    }
  },
  computed: {
    semesters() {
      let semesters = [];
      for (let semester = 1; semester <= 8; semester++) {
        let exists = true;
        let even = semester % 2 == 0;

        if (semester > 4 && this.item.student_type != "bachelor") {
          exists = false;
        }

        semesters.push({
          exists: exists,
          number: semester
        });
      }

      return semesters;
    }
  },
  created() {
    this.onSubjectTypeChange(this.type);
    if (this.preset) {
      this.restrictedType = this.preset.type;
      this.update(this.preset);
    }
  },
  methods: {
    update(item) {
      switch (item.type) {
        case "main": {
          this.type = {
            name: item.type,
            details: {
              theoretical: _.get(item.details, 'theoretical')
            }
          };
          break;
        }
        case "department": {
          this.type = {
            name: item.type,
            details: {
              department: {
                id: _.get(item.details, 'department.id')
              }
            }
          };
          break;
        }
        case "generic": {
          this.type = {
            name: item.type,
            details: {
              type: _.get(item.details, 'type')
            }
          };
          break;
        }
      }
      this.item.id = item.id;
      this.item.title = item.title;
      this.item.type = this.type.name;
      this.item.student_type = item.student_type;
      this.item.details = item.details;
      this.item.semesters = {
        exams: item.exams,
        no_exams: item.no_exams
      };
      this.item.teachers = item.teachers;
    },
    onUpdate() {
      this.$emit("update", this.item);
    },
    onStudentTypeChange(value) {
      if (this.preset) {
        return;
      }

      this.item.semesters.exams = [];
      this.item.semesters.no_exams = [];
    },
    onSubjectTypeChange(value) {
      this.item.details = _.merge(this.item.details, value.details);

      if (this.preset) {
        return;
      }

      this.item.type = value.name;

      switch (value.name) {
        case "generic": {
          this.item.semesters.exams = [];
          break;
        }
      }

      this.onUpdate();
    },
    getFilteredTeachers(text) {
      this.filteredTeachers = _.differenceBy(
        this.teachers,
        this.item.teachers,
        "id"
      ).filter(option => {
        return (
          option.full_name
            .toString()
            .toLowerCase()
            .indexOf(text.toLowerCase()) >= 0
        );
      });
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/models/Subject.vue